import educationLevelIndex from '@main/views/EducationLevel/Index/Index.vue'
import educationLevelShow from '@main/views/EducationLevel/Show/Show.vue'
import campaigns from '@main/views/campaigns.vue'

export const routes = [
  {
    path: "/",
    redirect: () => "campaigns"
  },
  {
    path: "/campaigns",
    name: 'campaigns',
    component: campaigns,
  },
  {
    path: '/campaigns/:education_level/:edu_form?',
    name: 'education_level_index',
    component: educationLevelIndex,
  },
  {
    path: '/campaigns/:education_level/:edu_form/contest_groups/:contest_group_id',
    name: 'education_level_show',
    component: educationLevelShow,
  },
]
